module.exports = __webpack_public_path__ + "static/img/swiper1.81b685d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swiper/swiper1.png
// module id = +0hw
// module chunks = 1